import { render, staticRenderFns } from "./AppPromotionAlert.vue?vue&type=template&id=5882b91e&scoped=true&"
import script from "./AppPromotionAlert.vue?vue&type=script&lang=js&"
export * from "./AppPromotionAlert.vue?vue&type=script&lang=js&"
import style0 from "./AppPromotionAlert.vue?vue&type=style&index=0&id=5882b91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882b91e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
